import {CALL_API} from 'middleware/api';

export const FAST_JOIN = 'FAST_JOIN';
export const SUCCESS_FAST_JOIN = 'SUCCESS_FAST_JOIN';
export const FAILURE_FAST_JOIN = 'FAILURE_FAST_JOIN';

export const FAST_CONFIRM_PHONE = 'FAST_CONFIRM_PHONE';
export const SUCCESS_FAST_CONFIRM_PHONE = 'SUCCESS_FAST_CONFIRM_PHONE';
export const FAILURE_FAST_CONFIRM_PHONE = 'FAILURE_FAST_CONFIRM_PHONE';

export function join(data) {
    return (dispatch) => {
        dispatch({
            type: FAST_JOIN,
            [CALL_API]: {
                endpoint: '/api/fast_join/',
                method: 'post',
                types: [SUCCESS_FAST_JOIN, FAILURE_FAST_JOIN],
                credentials: true,
                data
            }
        });
    };
}

export function confirmPhone(data) {
    return (dispatch) => {
        dispatch({
            type: FAST_CONFIRM_PHONE,
            [CALL_API]: {
                endpoint: '/api/fast_join/confirm',
                method: 'post',
                types: [SUCCESS_FAST_CONFIRM_PHONE, FAILURE_FAST_CONFIRM_PHONE],
                credentials: true,
                data
            }
        })
    };
}



// WEBPACK FOOTER //
// ./js/actions/auth/FastJoin.js